import { FullSlider } from '../../../vendorjs/FullSlider.class';
import { isSafari } from '../../../vendorjs/helpers/isSafari';

window.Alpine.data('heroSliderSpecial', () => {
  return {
    mobileSlider: null,
    desktopSlider: null,

    isScrolling: false,
    isSafari: isSafari(),

    arrowButtonsHidden: true,

    init() {
      const $mobileSlider = this.$refs.sliderMobile.querySelector(
        '.hero-slider-special--slider-area'
      );
      const $desktopSlider = this.$refs.sliderDesktop.querySelector(
        '.hero-slider-special--slider-area'
      );

      if (!$mobileSlider || !$desktopSlider) {
        console.warn(
          'Hero Slider Special: DOM Nodes for mobile or desktop slider missing, Slider not initialized'
        );
        return;
      }

      const fnSelectSlides = ({ $slider }) => {
        return $slider.querySelectorAll('.hero-slider-special--slide');
      };

      this.mobileSlider = new FullSlider({ $slider: $mobileSlider, fnSelectSlides });
      this.desktopSlider = new FullSlider({ $slider: $desktopSlider, fnSelectSlides });

      // hide arrow buttons if no slides or only one slide
      this.arrowButtonsHidden = this.getSlides({ $slider: $mobileSlider }).length <= 1;
    },

    scrollNextMobile() {
      if (this.isScrolling && this.isSafari) return;
      this.isScrolling = true;
      // animation is finshed after approx. 500ms
      setTimeout(() => {
        this.isScrolling = false;
      }, 500);
      this.mobileSlider.scrollNext();
    },

    scrollPrevMobile() {
      if (this.isScrolling && this.isSafari) return;
      this.isScrolling = true;
      // animation is finshed after approx. 500ms
      setTimeout(() => {
        this.isScrolling = false;
      }, 500);
      this.mobileSlider.scrollPrev();
    },

    scrollNextDesktop() {
      if (this.isScrolling && this.isSafari) return;
      this.isScrolling = true;
      // animation is finshed after approx. 500ms
      setTimeout(() => {
        this.isScrolling = false;
      }, 500);
      this.desktopSlider.scrollNext();
    },

    scrollPrevDesktop() {
      if (this.isScrolling && this.isSafari) return;
      this.isScrolling = true;
      // animation is finshed after approx. 500ms
      setTimeout(() => {
        this.isScrolling = false;
      }, 500);
      this.desktopSlider.scrollPrev();
    },

    getSlides({ $slider }) {
      return [...$slider.querySelectorAll('.hero-slider-special--slide')];
    },
  };
});
